// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"7df17888","153":"7df17888","495":"7df17888","838":"7df17888"}[chunkId] + ".chunk.css";
};